import { CancelButton, EditButton } from '@core/components/Buttons';
import { CustomExpandedPanel } from '@core/components/CustomExpandedPanel';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Grid } from '@material-ui/core';
import { ContaBancariaVisualizar } from 'app/main/pessoa/ContaBancaria';
import { EnderecoVisualizar } from 'app/main/pessoa/Endereco';
import React, { useState } from 'react';
import { FaTruck } from 'react-icons/fa';
import { FornecedorActions } from '../../store';
import { useFornecedor } from '../../store/fornecedorContext';
import DadosContatoVisualizar from './DadosContatoVisualizar';
import DadosGeraisVisualizar from './DadosGeraisVisualizar';

const FormVisualizar = ({ fornecedor }) => {
  const [expanded, setExpanded] = useState('dadosGerais');

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const { endereco = {}, conta = {} } = fornecedor.pessoa;
  const { contaBancaria = {} } = conta;
  return (
    <>
      <CustomExpandedPanel
        title="Dados gerais"
        expanded={expanded === 'dadosGerais'}
        onChange={handleChange('dadosGerais')}
      >
        <DadosGeraisVisualizar registro={fornecedor} />
      </CustomExpandedPanel>
      <CustomExpandedPanel title="Endereço" expanded={expanded === 'endereco'} onChange={handleChange('endereco')}>
        <Grid container spacing={3}>
          <EnderecoVisualizar endereco={endereco} />
        </Grid>
      </CustomExpandedPanel>
      <CustomExpandedPanel title="Contato" expanded={expanded === 'contato'} onChange={handleChange('contato')}>
        <DadosContatoVisualizar registro={fornecedor} />
      </CustomExpandedPanel>
      <CustomExpandedPanel title="Conta bancária" expanded={expanded === 'conta'} onChange={handleChange('conta')}>
        <Grid container spacing={3}>
          <ContaBancariaVisualizar contaDescricao={conta.descricao} contaBancaria={contaBancaria} />
        </Grid>
      </CustomExpandedPanel>
    </>
  );
};
const FornecedorVisualizar = () => {
  const [state, dispatch] = useFornecedor();
  const { visualizar, registro } = state;

  const fechar = () => FornecedorActions.fecharModalCadastro(dispatch);

  const editar = () => dispatch(FornecedorActions.editarVisualizar());

  return (
    <SimpleDialog open={visualizar} onClose={fechar}>
      <SimpleDialogContent
        header={{
          title: 'Cadastro de fornecedor',
          icon: <FaTruck />,
          toolbar: (
            <>
              <CancelButton onClick={fechar}>Fechar</CancelButton>
              {permissaoUtils.fornecedor().editar && !registro?.locked && (
                <EditButton onClick={editar}>Editar</EditButton>
              )}
            </>
          ),
        }}
        content={<FormVisualizar fornecedor={registro} />}
        contentStyle={{ padding: 0 }}
      />
    </SimpleDialog>
  );
};

export default FornecedorVisualizar;
